import { Field } from 'formik';
import PropTypes from 'prop-types';
import { _TextAreaWrapper as TextAreaWrapper } from './TextArea.style';
import { _Label as Label } from '../../Styled/Label';
import { _FieldDescription as FieldDescription } from '../../Styled/FieldDescription';

export const TextArea = ({ id, props }) => {
  const { label, required, maxLength, description } = props;

  return (
    <TextAreaWrapper>
      <Label htmlFor={id}>{label}</Label>
      {description ? <FieldDescription>{description}</FieldDescription> : ''}
      <Field
        as={'textarea'}
        id={id}
        name={`form['${label}']`}
        required={required}
        maxLength={maxLength}
        rows={4}
      />
    </TextAreaWrapper>
  );
};

TextArea.propTypes = {
  id: PropTypes.string.isRequired,
  props: PropTypes.shape({
    label: PropTypes.string.isRequired,
    required: PropTypes.bool,
    maxLength: PropTypes.number,
  }).isRequired,
};
